declare global {
  interface Number {
    toLocale(minimumFractionDigits?: number, maximumFractionDigits?: number): string;
  }
}

/**
 * Format this number according to the current locale, using the
 * following settings:
 *
 * - `minimumFractionDigits`: 0
 * - `maximumFractionDigits`: 8
 *
 * @returns {string} The formatted number
 */
Number.prototype.toLocale = function (
  minimumFractionDigits?: number,
  maximumFractionDigits?: number,
) {
  return this.toLocaleString("en", {
    minimumFractionDigits: minimumFractionDigits ?? 0,
    maximumFractionDigits: maximumFractionDigits ?? 0,
  });
};

export {};
